import getPage from "@/redux/slices/admin/thunks/getPage";
import postPage from "@/redux/slices/admin/thunks/postPage";
import putPage from "@/redux/slices/admin/thunks/putPage";
import deletePage from "@/redux/slices/admin/thunks/deletePage";
import putPagePublic from "@/redux/slices/admin/thunks/putPagePublic";
import duplicatePage from "@/redux/slices/admin/thunks/duplicatePage";
import addComment from "@/redux/slices/admin/thunks/addComment";
import deleteComment from "@/redux/slices/admin/thunks/deleteComment";
import updateCmsConfigVariable from "@/redux/slices/admin/thunks/updateCmsConfigVariable";

const thunks = [
  getPage,
  putPage,
  postPage,
  deletePage,
  putPagePublic,
  duplicatePage,
  addComment,
  deleteComment,
  updateCmsConfigVariable,
];

export default thunks;
